// @flow
import {
    COMPLETE_COMPLETE_ACCOUNT_MODAL,
    COMPLETE_CONFIRM_PASSWORD_MODAL,
    COMPLETE_FOLLOW_SEARCH_MODAL,
    COMPLETE_LOGIN_MODAL,
    COMPLETE_SIGN_UP_MODAL,
    DISMISS_MODAL,
} from './modal';
import { COMPLETE_ACCOUNT_SUCCESS } from './completeAccount';
import { createSelector } from 'reselect';
import type { GlobalState } from '../rootReducer';

/* Action Types */
export const OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER';
export const OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER';
export const OPEN_LOGIN_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_LOGIN_MODAL_FROM_CHECKER';
export const OPEN_FOLLOW_SEARCH_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_FOLLOW_SEARCH_MODAL_FROM_CHECKER';
export const OPEN_SET_PASSWORD_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_SET_PASSWORD_MODAL_FROM_CHECKER';
export const OPEN_SIGN_UP_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_SIGN_UP_MODAL_FROM_CHECKER';
export const OPEN_PREFERENCES_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_PREFERENCES_MODAL_FROM_CHECKER';
export const STOP_TRACKER = 'la/ui/shouldLogin/STOP_TRACKER';

/* reducer */
const DEFAULT_STATE = {
    completeAccountModalOpen: false,
    confirmPasswordModalOpen: false,
    followSearchModalOpen: false,
    loginModalOpen: false,
    setPasswordModalOpen: false,
    signUpModalOpen: false,
    startTracking: false,
    trigger: '',
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER:
            return {
                ...state,
                completeAccountModalOpen: true,
                confirmPasswordModalOpen: false,
                followSearchModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                signUpModalOpen: false,
                startTracking: true,
                trigger: action.trigger,
            };
        case OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER: // do we need this?
            return {
                ...state,
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: true,
                followSearchModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                signUpModalOpen: false,
                startTracking: true,
                trigger: action.trigger,
            };
        case OPEN_LOGIN_MODAL_FROM_CHECKER:
            return {
                ...state,
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                followSearchModalOpen: false,
                loginModalOpen: true,
                setPasswordModalOpen: false,
                signUpModalOpen: false,
                startTracking: true,
                trigger: action.trigger,
            };
        case OPEN_SET_PASSWORD_MODAL_FROM_CHECKER:
            return {
                ...state,
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: true,
                signUpModalOpen: false,
                startTracking: true,
                trigger: action.trigger,
            };
        case OPEN_SIGN_UP_MODAL_FROM_CHECKER:
            return {
                ...state,
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                followSearchModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                signUpModalOpen: true,
                startTracking: true,
                trigger: action.trigger,
            };
        case OPEN_FOLLOW_SEARCH_MODAL_FROM_CHECKER:
            return {
                ...state,
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                followSearchModalOpen: true,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                signUpModalOpen: false,
                startTracking: true,
                trigger: action.trigger,
            };
        case COMPLETE_COMPLETE_ACCOUNT_MODAL:
            return {
                ...state,
                completeAccountModalOpen: false,
            };
        case COMPLETE_LOGIN_MODAL:
            return {
                ...state,
                loginModalOpen: false,
            };
        case COMPLETE_SIGN_UP_MODAL:
            return {
                ...state,
                signUpModalOpen: false,
            };
        case COMPLETE_ACCOUNT_SUCCESS:
            return {
                ...state,
                completeAccountModalOpen: false,
            };
        case COMPLETE_CONFIRM_PASSWORD_MODAL: // TODO there is not action for this
            return {
                ...state,
                confirmPasswordModalOpen: false,
            };
        case COMPLETE_FOLLOW_SEARCH_MODAL:
            return {
                ...state,
                followSearchModalOpen: false,
            };
        case STOP_TRACKER:
            return {
                ...state,
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                followSearchModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                signUpModalOpen: false,
                startTracking: false,
                trigger: '',
            };
        case DISMISS_MODAL:
            return {
                ...state,
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                followSearchModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                signUpModalOpen: false,
                startTracking: false,
                trigger: '',
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.shouldLogin;

export const isTracking = createSelector(stateSelector, state => state.startTracking);

export const isLoginModalOpen = createSelector(stateSelector, state => state.loginModalOpen);

export const isCompleteAccountModalOpen = createSelector(stateSelector, state => state.completeAccountModalOpen);

export const isFollowSearchModalOpen = createSelector(stateSelector, state => state.followSearchModalOpen);

export const getTriggerId = createSelector(stateSelector, state => {
    return state.trigger ? state.trigger : null;
});

/* ACTION CREATORS */
export const openLoginModalFromChecker = (trigger: string) => ({
    trigger,
    type: OPEN_LOGIN_MODAL_FROM_CHECKER,
});

export const openCompleteAccountModalFromChecker = (trigger: string) => ({
    trigger,
    type: OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER,
});

export const openConfirmPasswordModalFromChecker = (trigger: string) => ({
    trigger,
    type: OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER,
});

export const openFollowSearchModalFromChecker = (trigger: string, searchParams: any) => ({
    searchParams,
    trigger,
    type: OPEN_FOLLOW_SEARCH_MODAL_FROM_CHECKER,
});

export const openSetPasswordModalFromChecker = (trigger: string) => ({
    trigger,
    type: OPEN_SET_PASSWORD_MODAL_FROM_CHECKER,
});

export const openSignUpModalFromChecker = (trigger: string) => ({
    trigger,
    type: OPEN_SIGN_UP_MODAL_FROM_CHECKER,
});

export const stopTracker = () => ({
    type: STOP_TRACKER,
});
